import type { PlacementIdConfig } from './types';

export const RESULTS_DECISION = {
  ONLY_PGR: 'ONLY_PGR',
  CONTAINS_PGR: 'CONTAINS_PGR',
  NO_PGR: 'NO_PGR',
} as const;

export const GENDER_IDENTITY_TYPE = {
  MALE: 'M',
  FEMALE: 'F',
  NON_BINARY: 'X',
} as const;

export const LICENSE_STATUS = {
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
  INTERNATIONAL: 'International',
  LEARNER: 'Learner',
  NONE: 'None',
  OTHER: 'Other',
  PERMIT: 'Permit',
  PROBATION: 'Probation',
  RESTRICTED: 'Restricted',
  REVOKED: 'Revoked',
  SUSPENDED: 'Suspended',
  TEMPORARY: 'Temporary',
} as const;

export const MARRIAGE_STATUS = {
  SINGLE: 'Single',
  MARRIED: 'Married',
  DIVORCED: 'Divorced',
  SEPARATED: 'Separated',
  WIDOWED: 'Widowed',
  DOMESTIC_PARTNER: 'Domestic Partner',
  UNKNOWN: 'Unknown',
} as const;

export const GENDER_IDENTITY = {
  MALE: GENDER_IDENTITY_TYPE.MALE,
  FEMALE: GENDER_IDENTITY_TYPE.FEMALE,
  NON_BINARY: GENDER_IDENTITY_TYPE.NON_BINARY,
};

export const POPBACK_PLACEMENT_ID = 'hrs9CJcNDMuaBnAtq1rDK_xVOPeiQA';

/*
 * Media Alpha Stage Testing
 * We map using existing QS SRC IDs to ensure we can still get QS offers
 * To ensure offers for multi match case, try using zip 17601
 * To ensure no offers for no offers case, try using zip 94949
 */
export const TEST_PLACEMENT_IDS: Record<string, PlacementIdConfig> = {
  // Arbitrarily maps to Auto Ad Campaign 2
  '691445': {
    name: 'PGR multi match',
    id: '_ZXG0c5akgRcmTxIimDDjKINzo079g',
  },
  // Arbitrarily maps to Auto 9
  '694283': {
    name: 'PGR direct match',
    id: 'GHmJ4KlTjNoA8O3s-yp-pS7z0xCRZA',
  },
  // Arbitrarily maps to SEM Desktop 1
  '696228': {
    name: 'No offers',
    id: 'UuFI8HojMWrrJR8aEvmZqCrMnGrdVA',
  },
};

export const PLACEMENT_IDS: Record<string, PlacementIdConfig> = {
  '692336': {
    name: 'Affiliate Campaign 2', // also used for stage testing
    id: 'ZVsjF5XW7HnNs1qheFK0Ue-2K2Js7A',
  },
  '692986': {
    name: 'Affiliate Campaign 2A',
    id: 'nKEFixoHaoyUWPlm-4eyoNcLcUTHIw',
  },
  '664420': {
    name: 'Auto 2',
    id: 'fhZb5b3PaW0pEHh9t6Gs8pG9JfcqtQ',
  },
  '667896': {
    name: 'Auto 6',
    id: 'yUWqYZjO0yvbblDXOHX0tZSEWNNR9g',
  },
  '667897': {
    name: 'Auto 7',
    id: 'YwTYhUPJFWZkAXGmkqd9jqi7V8jD1Q',
  },
  '694283': {
    name: 'Auto 9',
    id: 'F_jdyW0g-kfiZVvC23joZaKydWAkjw',
  },
  '669282': {
    name: 'Auto B Mobile',
    id: 'Q1u-sO4WKPppS6D0m_vPRzZW2mvvqA',
  },
  '667919': {
    name: 'Auto CRM',
    id: 'DDkVg3UK-5_QaIEoEagjd9hJGnG6Mw',
  },
  '691840': {
    name: 'Auto G Desktop 3',
    id: '8gn1kpdAvyg78z4tqPvHGpj4_Q5zag',
  },
  '669281': {
    name: 'Auto G Mobile',
    id: 'c8ifwR9m6isb7XR1aV6NF2KcZANbTA',
  },
  '691841': {
    name: 'Auto G Mobile 3',
    id: 'AwrICpWJ6lh4DdUNj8W3fj9EXUjjTQ',
  },
  '693612': {
    name: 'Auto G5',
    id: 'hSORar50tMX86gTh3NSNYU7sINzNOA',
  },
  '664413': {
    name: 'Non Premium ZIP Widget Start', // default
    id: 'nrIGC2yJB1Odu2YvGDa5bGh2oAuduw',
  },
  '664412': {
    name: 'Premium ZIP Widget Start',
    id: '4Qct8jkyB3tLcLnowGgcIzUzzgIWbA',
  },
  '696229': {
    name: 'Social FB 2',
    id: 'DwrbsNcm2F9Gk5BbgdUF4VNiV5EMqQ',
  },
  '700988': {
    name: 'Affiliate Campaign - FB 3',
    id: 'Vu8z9qLKYvMi0QzjzHtL8hQ-32c7XA',
  },
  '701337': {
    name: 'Affiliate Campaign - Social 2',
    id: 'IRGsFSJynVWdgoHzQqTxdAb5f5lSgA',
  },
  '691445': {
    name: 'Auto Ad Campaign 2',
    id: 'W_FBBzkRXqzy_pZBxaOBDc6penSXDA',
  },
  '663706': {
    name: 'Interstitial',
    id: 'f0DAX9w713QCjbhFld2rx2BxaRmmtg',
  },
  '664395': {
    name: 'Auto L Drop Down Widget',
    id: 'kioQd-wHN_STkTzEm4P7Ji8KTzTtBA',
  },
  '664580': {
    name: 'Drop Down Widget NW',
    id: 'YjkAS3-yQ_5LblXiEHVs61Qvu6K4-Q',
  },
  '665486': {
    name: 'Renters',
    id: 'uiZkA3LkSqm00zOBFMhHFWdXvkwbsQ',
  },
  '693229': {
    name: 'Auto CRM 2',
    id: 'zmQTzuN8OBKWZbcxH1EHewmRdVw1wg',
  },
  '693513': {
    name: 'Affiliate Campaign 2B',
    id: 'aL6XKx_SPqMP6cyL3NuLtMK_IQBnkQ',
  },
  '693514': {
    name: 'CRM PL',
    id: 'zfXIVYb9KQNCqBYn68quaBFmGjhXxA',
  },
  '694020': {
    name: 'Auto Social TT',
    id: 'OWPYLnFdRLs_P2dD6cl1z7-9igH9-w',
  },
  '696228': {
    name: 'SEM Desktop 1',
    id: 'WUxY2IgKABtUs4XYCVV8SdReScZDUA',
  },
  '701497': {
    name: 'Social 3',
    id: 'HfXbOAUygvb0o7zq7JLHo8_jdRwnyA',
  },
  '691092': {
    name: 'Home 6',
    id: 'mWcfx5usu6S0tz3yIbmMgYOnAQU_Tg',
  },
  '701338': {
    name: 'Desktop SEM',
    id: 'yevDrt_RRwRzvg6XBY03mGDXkqaxCA',
  },
  '662940': {
    name: 'Drop Down Widget Home',
    id: 'qXNEKsxaa_QWuvMT144zWc5iSFJDJQ',
  },
  '701339': {
    name: 'B Desktop SEM',
    id: 'gdtqBeifqFBoIZFlA0P0e1ouQX83xQ',
  },
  '701340': {
    name: 'Mobile SEM',
    id: 'kmr0qxfuKLLpTGUqTd0UuCZ-GlklsA',
  },
  '702280': {
    name: 'Auto - Native',
    id: 'l6PNCKq8xzfd3O-68am5Nlr1xpY0Vg',
  },
};

export const VERTICALS = {
  MEDICARE: 'medicare',
  AUTO: 'auto_insurance',
  LIFE: 'life_insurance',
  HOME: 'home_insurance',
  PET: 'pet_insurance',
  TRAVEL: 'travel_insurance',
  AGENCY: 'agency_insurance',
} as const;

export const MARKETPLACE_DATA = {
  skuId: '8bf7e008-3978-11ef-adbc-276787edf7dc',
  skuName: 'Media Alpha insurance Flow',
  skuProductType: VERTICALS.HOME,
  institutionId: '64014c42-3978-11ef-a1b0-efc5c81bcf11',
  institutionName: 'Media Alpha',
  productId: '7a6c3c62-3978-11ef-9116-fbce46418b8f',
  productName: 'Media Alpha Insurance Flow',
};

// make sure changes made in apps/web/src/utils/constants.ts are reflected here as well
export const NW_TO_MA_INSURER_MAP: Record<string, string> = {
  'State Farm': 'State Farm Insurance',
  Allstate: 'Allstate Insurance',
  USAA: 'USAA General Indemnity',
  'Liberty Mutual': 'Liberty Mutual Insurance',
  Farmers: 'Farmers Insurance',
  Travelers: 'Travelers Insurance Company',
  Other: 'Other',
};

export const AFFILIATE_CAMPAIGN_DEFAULT_HOME_PLACEMENT_ID_MA =
  'NI4QolalMAOZaSvBhepmOlHY-6gghA';
